// Dashboard Actions
import { safeSetSessionStorage } from '../../utils/storageUtils';

export const CHANGE_SELECTED_SERVICE = 'CHANGE_SELECTED_SERVICE';
export const SET_INITIAL_SERVICE = 'SET_INITIAL_SERVICE';
export const UPDATE_DASHBOARD_DATA = 'UPDATE_DASHBOARD_DATA';

// Action to change the selected service
export const changeSelectedService = (service) => {
  // Persist selected service slug for reload persistence
  if (service) {
    safeSetSessionStorage('selectedServiceSlug', String(service));
  }
  return {
    type: CHANGE_SELECTED_SERVICE,
    payload: { service }
  };
};

// Action to set initial service from user data
export const setInitialService = (service) => ({
  type: SET_INITIAL_SERVICE,
  payload: { service }
});

// Action to update dashboard data
export const updateDashboardData = (data) => ({
  type: UPDATE_DASHBOARD_DATA,
  payload: { data }
});

// Async action to change service and reload data
export const switchService = (service) => async (dispatch, getState) => {
  try {
    // Change the selected service (real data is fetched by components/effects)
    dispatch(changeSelectedService(service));
  // Navigate to dynamic dashboard without passing service in query
  window.location.href = '/dashboard';
    
  } catch (error) {
    // Error switching service - continue silently
  }
};
